import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { EmptyState } from "../../components/EmptyState";
import { Label } from "../../types/Label.type";
import { TournamentTableRow } from "./TournamentTableRow";
import { selectFilteredTournamentIds } from "./tournaments.feature";

export const TournamentsTable = () => {
  const tournamentIds = useAppSelector(selectFilteredTournamentIds);

  if (tournamentIds.length > 0) {
    return (
      <TableContainer>
        <Table size="small">
          <caption>{tournamentIds.length} tournament(s) found</caption>
          <TableHead>
            <TableRow
              sx={{
                "& th": { fontWeight: 600 },
              }}
            >
              <TableCell>Status</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Round</TableCell>
              <TableCell>Date</TableCell>
              <TableCell sx={{ width: 128 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tournamentIds.map((id) => (
              <TournamentTableRow id={id} key={id} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  } else {
    return (
      <EmptyState
        icon={<EmojiEventsIcon fontSize="large" />}
        label={Label.Tournament}
      />
    );
  }
};
